<template>
<div id="quickview" class="quickview-wrapper" data-pages="quickview">
  <!-- Nav tabs -->
  <ul class="nav nav-tabs">
    <li class="">
      <a href="#quickview-notes" data-toggle="tab">Notes</a>
    </li>
    <li>
      <a href="#quickview-alerts" data-toggle="tab">Alerts</a>
    </li>
    <li class="active">
      <a href="#quickview-chat" data-toggle="tab">Chat</a>
    </li>
  </ul>
  <a class="btn-link quickview-toggle" data-toggle-element="#quickview" data-toggle="quickview"><i class="pg-close"></i></a>
  <!-- Tab panes -->
  <div class="tab-content">
    <!-- BEGIN Notes !-->
    <div class="tab-pane fade in no-padding" id="quickview-notes">
      <Notes />
    </div>
    <!-- END Notes !-->
    <!-- BEGIN Alerts !-->
    <div class="tab-pane fade no-padding" id="quickview-alerts">
      <Alerts />
    </div>
    <!-- END Alerts !-->
    <div class="tab-pane fade in active no-padding" id="quickview-chat">
      <Chat />      
    </div>
  </div>
</div>
</template>

<script>

  import Alerts from './pages/alerts.vue';
  import Chat from './pages/chat.vue';
  import Notes from './pages/notes.vue';  

  export default {
    name: 'QuickView',
    components: {
      Alerts,
      Chat,
      Notes      
    }    
  }

</script>


// WEBPACK FOOTER //
// quick_view.vue?72e5501a